import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Collapse, Button } from "react-bootstrap";
import {
  FileQuestion,
  GraduationCap,
  Home,
  BookOpen,
  User,
  LogOut,
  ClipboardList,
  PlusCircle,
  BarChart3,
} from "lucide-react";
import { logout } from "../helper/auth"; // 👈 helper to clear auth data (token, user info, etc.) from localStorage or context


const Sidebar = ({ collapsed, onLogout }) => {
  const [openQuestionBank, setOpenQuestionBank] = useState(false);
  const [openStudentExam, setOpenStudentExam] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout_ = () => {
  localStorage.removeItem("adminToken");
  localStorage.removeItem("user");
  onLogout();
  navigate("/", { replace: true });
  };

  const handleLogout = () => {
    onLogout(); // 👈 call parent logout
  };

  const isActive = (path) => location.pathname === path;

  const menuItemStyle = {
    textDecoration: "none",
    color: "white",
    display: "flex",
    alignItems: "center",
    padding: "8px 12px",
    borderRadius: "8px",
    fontSize: "15px",
    marginBottom: "4px",
    transition: "background 0.2s",
  };

  const iconStyle = {
    marginRight: collapsed ? "0" : "10px",
  };

  return (
    <div
  className="bg-dark text-white d-flex flex-column justify-content-between"
  style={{
    width: collapsed ? "70px" : "240px",
    minWidth: collapsed ? "70px" : "240px", // 🔥 ADD THIS
    maxWidth: collapsed ? "70px" : "240px", // 🔥 ADD THIS
    flexShrink: 0, // 🔥 CRITICAL FIX
    transition: "width 0.3s ease",
    height: "100vh",
    position: "sticky",
    top: 0,
  }}
>
      {/* Top Menu Section */}
      <div className="p-2">
        {/* Header */}
        <div
          className="text-center mb-3"
          style={{
            fontSize: collapsed ? "0" : "18px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            transition: "font-size 0.2s",
          }}
        >
          <strong>Admin Panel</strong>
        </div>

        {/* Dashboard */}
        <Link
          to="/dashboard"
          style={{
            ...menuItemStyle,
            background: isActive("/dashboard") ? "#343a40" : "transparent",
          }}
        >
          <Home size={20} style={iconStyle} />
          {!collapsed && "Dashboard"}
        </Link>

        {/* Student Exam (Collapsible) */}
        <Button
          variant="link"
          onClick={() => setOpenStudentExam(!openStudentExam)}
          className="text-white text-start w-100"
          aria-controls="collapse-student-exam"
          aria-expanded={openStudentExam}
          style={{
            ...menuItemStyle,
            background: openStudentExam ? "#343a40" : "transparent",
          }}
        >
          <GraduationCap size={20} style={iconStyle} />
          {!collapsed && "Student Exam"}
        </Button>

        <Collapse in={openStudentExam}>
          <div id="collapse-student-exam" className="ps-3">
            <Link
              to="/dashboard/all-exams"
              style={{
                ...menuItemStyle,
                background: isActive("/dashboard/all-exams")
                  ? "#495057"
                  : "transparent",
                fontSize: collapsed ? "0" : "14px",
              }}
            >
              <ClipboardList size={18} style={iconStyle} />
              {!collapsed && "All Exams"}
            </Link>

            <Link
              to="/dashboard/add-exam"
              style={{
                ...menuItemStyle,
                background: isActive("/dashboard/add-exam")
                  ? "#495057"
                  : "transparent",
                fontSize: collapsed ? "0" : "14px",
              }}
            >
              <PlusCircle size={18} style={iconStyle} />
              {!collapsed && "Add Exam"}
            </Link>

            <Link
              to="/dashboard/exam-results"
              style={{
                ...menuItemStyle,
                background: isActive("/dashboard/exam-results")
                  ? "#495057"
                  : "transparent",
                fontSize: collapsed ? "0" : "14px",
              }}
            >
              <BarChart3 size={18} style={iconStyle} />
              {!collapsed && "Exam Results"}
            </Link>
          </div>
        </Collapse>

        {/* Question Bank Collapsible */}
        <Button
          variant="link"
          onClick={() => setOpenQuestionBank(!openQuestionBank)}
          className="text-white text-start w-100"
          aria-controls="collapse-question-bank"
          aria-expanded={openQuestionBank}
          style={{
            ...menuItemStyle,
            background: openQuestionBank ? "#343a40" : "transparent",
          }}
        >
          <FileQuestion size={20} style={iconStyle} />
          {!collapsed && "Question Bank"}
        </Button>

        <Collapse in={openQuestionBank}>
          <div id="collapse-question-bank" className="ps-3">
            <Link
              to="/dashboard/add-question-bank"
              style={{
                ...menuItemStyle,
                background: isActive("/dashboard/add-question-bank")
                  ? "#495057"
                  : "transparent",
                fontSize: collapsed ? "0" : "14px",
              }}
            >
              <BookOpen size={18} style={iconStyle} />
              {!collapsed && "Add Question bank"}
            </Link>
            <Link
              to="/dashboard/add-question"
              style={{
                ...menuItemStyle,
                background: isActive("/dashboard/add-question")
                  ? "#495057"
                  : "transparent",
                fontSize: collapsed ? "0" : "14px",
              }}
            >
              <BookOpen size={18} style={iconStyle} />
              {!collapsed && "Add Question"}
            </Link>

            <Link
              to="/dashboard/question-bank"
              style={{
                ...menuItemStyle,
                background: isActive("/dashboard/question-bank")
                  ? "#495057"
                  : "transparent",
                fontSize: collapsed ? "0" : "14px",
              }}
            >
              <User size={18} style={iconStyle} />
              {!collapsed && "View Questions"}
            </Link>
          </div>
        </Collapse>
      </div>

      {/* Bottom Logout Section */}
      <div className="p-2 border-top border-secondary">
        <Button
          variant="link"
          onClick={handleLogout}
          className="text-white w-100 text-start"
          style={{
            ...menuItemStyle,
            background: "#212529",
            justifyContent: collapsed ? "center" : "flex-start",
          }}
        >
          <LogOut size={20} style={iconStyle} />
          {!collapsed && "Logout"}
        </Button>
      </div>
    </div>
  );
};

export default Sidebar;
